import { render, staticRenderFns } from "./ArrowRightInfo.vue?vue&type=template&id=975fdf8c&"
import script from "./ArrowRightInfo.vue?vue&type=script&lang=ts&"
export * from "./ArrowRightInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports